import { Injectable } from '@angular/core';

@Injectable()
export class WindowService {

  constructor() { }

  get window(): Window {
    return window;
  }
}
